const eventName = 'send_contact_form';

window.dataLayer = window.dataLayer || [];

window.addEventListener(
    'hs-form-event:on-submission:success',
    () => {
        window.dataLayer.push({ event: eventName });
    },
    true,
);
